<template>
	<div v-if="!loading && polls.length">
		<SinglePoll v-if="!loading" v-for="p in polls" :poll-data="p.poll" :poll-options="p.options" @refresh="getPollsData"/>
	</div>
</template>

<script>
import SinglePoll from '../components/SinglePoll.vue';

export default {
	name: 'Polls',
	components: { SinglePoll },
	inject: ['WP'],
	data() {
		return {
      pollsMeta: [],
			polls: [],
			loading: true,
      lastRefresh: null,
    }
	},
	mounted() {
    this.getPollsACF();
	},
  methods: {
    getPollsData() {
      if (this.lastRefresh === null || this.lastRefresh < Date.now() - 5000) {
        axios
            .post(this.WP.ajaxUrl, {
              endpoint: 'api_get_polls',
              polls_meta: this.pollsMeta,
            })
            .then((response) => {
              this.polls = response.data.data;
              this.loading = false;
              this.lastRefresh = Date.now()
              if (this.polls.some(poll => {
                return !this.hasPollEnded(poll);
              })) {
                setTimeout(() => {
                  this.getPollsData();
                }, 60 * 1000)
              }
            })
      }
    },
    getPollsACF() {
      axios
        .get(`/wp-json/acf/v3/posts/${this.WP.id}/polls`)
        .then(response => {
          if(response.data.polls?.length > 0) {
            for (let i = 0; i < response.data.polls.length; i++) {
              const poll = response.data.polls[i];
              this.pollsMeta.push({
                id: this.WP.id,
                title: poll.poll_title
              })
            }
            this.getPollsData();
          }
        })
    },
    hasPollEnded(pollData) {
      if (pollData.end_date) {
        const pollEndDate = DateTime.fromSQL(pollData.end_date).ts;
        const currentTime = DateTime.now().ts;
        return currentTime > pollEndDate;
      }
      return false;
    },
  }

}
</script>